import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import { Select } from 'radix-ui';
import styled from 'styled-components';
import CheckIcon from '../../../../public/images/icons/check.svg';

export const StyledTrigger = styled(Select.Trigger)`
  all: unset;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  border-radius: 100px;
  width: 100%;
  
  &:focus {
    outline: 2px solid -webkit-focus-ring-color;
    outline-offset: 0px;
    border-radius: 100px;
  }
`;

export const StyledTriggerWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;

export const StyledContent = styled(Select.Content)`
  background-color: ${({ theme }) => theme.colors.highEmphasisWhite};
  outline: 0;
  padding: 0;
  margin: 0;
  list-style-type: none;
  box-shadow: ${({ theme }) => theme.elevation[3]};
  border-radius: 4px;
  overflow: hidden;
  z-index: 100;
`;

export const StyledViewport = styled(Select.Viewport)`
  padding: 0;
`;

export const StyledItem = styled(Select.Item)<{ $isSelected?: boolean }>`
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing[12]} ${theme.spacing[16]}`};
  background-color: ${({ theme }) => theme.colors.highEmphasisWhite};
  cursor: pointer;
  gap: ${({ theme }) => theme.spacing[16]};
  
  ${({ theme, $isSelected }) =>
    $isSelected &&
    `
    font-weight: ${theme.fontWeight.medium};
  `}
  
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.pressedBlack};
  }
  
  &:hover, &:focus {
    background-color: ${({ theme }) => theme.colors.surface02};
  }
  
  &:first-child {
    border-radius: 4px 4px 0 0;
  }
  
  &:last-child {
    border-radius: 0 0 4px 4px;
  }
`;

export const StyledItemText = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})`
  font-weight: inherit;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
`;

export const StyledItemIndicator = styled(Select.ItemIndicator)`
  flex-shrink: 0;
`;

export const StyledCheckIcon = styled(CheckIcon)`
  flex-shrink: 0;
  fill: ${({ theme }) => theme.colors.highEmphasisBlack};
`;
